import React from "react";
import "../styles/PopularTours.css";
import img1 from "../assets/abudhabi.webp";
import img2 from "../assets/kerala.webp";
import img3 from "../assets/varanasi.webp";

const toursData = [
{
    img: img1,
    duration: "5 Days",
    price: "From ₹45,000",
    rating: "⭐️⭐️⭐️⭐️⭐️ (12)",
    description: "Explore Abu Dhabi’s top attractions, including the iconic Sheikh Zayed Grand Mosque, Ferrari World, luxury experiences, cultural landmarks, and unforgettable desert adventures in the UAE.",
    location: "Abu Dhabi, UAE"
  },
  {
    img: img2,
    duration: "10 Days",
    price: "From ₹52,000",
    rating: "⭐️⭐️⭐️⭐️⭐️ (14)",
    description: "Explore Kerala’s breathtaking backwaters, pristine beaches, lush hill stations, and scenic landscapes with unforgettable nature tours, houseboat experiences, and relaxing travel escapes.",
    location: "Alleppey, Kerala"
  },
  {
    img: img3,
    duration: "5 Days",
    price: "From ₹32,000",
    rating: "⭐️⭐️⭐️⭐️☆ (6)",
    description: "Experience the spiritual beauty of the holy Ganges River with iconic ghats, ancient temples, mesmerizing Ganga Aarti ceremonies, and unforgettable cultural experiences in India.",
    location: "Varanasi, Uttar Pradesh"
  }
];

const PopularTours = () => {
  return (
    <div className="tours-section">
      <div className="tours-header">
        <h2 className="section-title">Featured Tours</h2>
        <h3 className="section-subtitle">Most Popular Tours</h3>
      </div>

      <div className="tours-grid">
        {toursData.map((tour, i) => (
          <div className="tour-card" key={i}>
            <div className="tour-image">
              <img src={tour.img} alt={`Tour ${i + 1}`} />
              <div className="tour-duration">{tour.duration}</div>
            </div>
            <div className="tour-details">
              <div className="price-rating">
                <span className="price">{tour.price}</span>
                <span className="rating">{tour.rating}</span>
              </div>
              <p className="tour-description">{tour.description}</p>
              <p className="tour-location">{tour.location}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularTours;
